"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
/* eslint-disable */
/* tslint:disable */
var React = tslib_1.__importStar(require("react"));
var ImportUpload = function (_a) {
    var size = _a.size, props = tslib_1.__rest(_a, ["size"]);
    return (React.createElement("svg", tslib_1.__assign({ viewBox: "0 0 19 16", fill: "currentColor", width: size || "19", height: size || "16" }, props),
        React.createElement("path", { d: "M9 4.833l-2.414 2.41-.707-.707L9.502 2.92l.082.082L9.586 3l3.535 3.536-.707.707L10 4.828V10H9V4.833zM9 13H1a1 1 0 0 1-1-1V1a1 1 0 0 1 1-1h17a1 1 0 0 1 1 1v11a1 1 0 0 1-1 1h-8v2h4v1H5v-1h4v-2zM1 1v11h17V1H1z" })));
};
ImportUpload.displayName = 'ImportUpload';
exports.default = ImportUpload;
/* tslint:enable */
/* eslint-enable */
//# sourceMappingURL=ImportUpload.js.map